import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ScanTarget } from 'src/app/models/ScanTargetModel';
import { ScanResult } from 'src/app/models/ScanResultModel';
import { ResultFilter, Results } from 'src/app/services/platform-api.service';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
const xml2Js = require('xml2js');

@Component({
  selector: 'cw-ci-scan-xccdf-result-summary',
  templateUrl: './scan-result-xccdf-summary.component.html',
  styleUrls: ['./scan-result-xccdf-summary.component.scss']
})
export class ScanResultXccdfSummaryComponent implements OnInit {

  @Input() parentAccount: Account;
  @Input() account: Account;
  @Input() scanTarget: ScanTarget;
  @Input() _scanResult: ScanResult;

  @Input() set scanResult(value: ScanResult) {
    this._scanResult = value;
    this.resultJson = JSON.parse(value.results);
    this.resultRulesDataTable.executeLoadItems();
  }

  @ViewChild(DataTableComponent, { static: true }) resultRulesDataTable: DataTableComponent;

  resultJson: any;
  ruleResults: Results;

  constructor(public themeService: ThemeManagerService, public dialog: MatDialog) { }

  ngOnInit() {
  }

  isSelectable(event) {
    return true;
  }

  loadScanResults(filter: ResultFilter) {
    const sortedRulesResults = this.resultJson.rule_results.sort((a,b) => {
      let aa = a[filter.sortField];
      let bb = b[filter.sortField];

      if (filter.sortOrder == 'desc') {
        const tmp = bb;
        bb = aa;
        aa = tmp;
      }

      if (isNaN(Number(aa))) {
        if (aa == bb) {
          return 0;
        } else if (aa < bb) {
          return -1;
        } else {
          return 1;
        }
      } else {
        return aa - bb;
      }
    });
    this.ruleResults = new Results(sortedRulesResults.slice(filter.startIndex, filter.startIndex+filter.pageSize), this.resultJson.rule_results.length);
    console.log(this.scanTarget, this.ruleResults);
  }

  openReference(event: any, identifier: string) {
    event.stopPropagation();
    if (identifier.startsWith('CCI')) {
      window.open(`https://jovalcm.com/references/cci/${identifier}/`, '_blank');
    } else if (identifier.startsWith('CCE')) {
      window.open(`http://www.scaprepo.com/control.jsp?command=search&search=${identifier}`, '_blank');
    } else if(identifier.startsWith('CVE')) {
      window.open(`https://nvd.nist.gov/vuln/detail/${identifier}`, '_blank');
    }
  }

  selectRule(rule: any) {
    if(rule.rule_id.startsWith('xccdf_mil.disa.stig_')){
      xml2Js.parseStringPromise(rule.rule_description).then(ruleDesc => {
        this.displayDialog(ruleDesc.VulnDiscussion);
      })
      .catch((err) => {
        console.error(err);
      });
    } else if(rule.rule_id.startsWith('xccdf_org.joval_')) {
      this.displayDialog(rule.rule_description);
    } else {
      console.error("Unsupported format. Rule_id: " + rule.rule_id);
    }
  }

  displayDialog(message: string) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptTitle: 'Description',
        promptMessage: [
          message
        ],
        buttons: [],
        height: 'auto'
      }
    });
  }
}
